import BaseAddEditModal from '../../components/base/BaseAddEditModal';
import React from 'react';

const AddEditHomeBannerModal = ({ isOpen, onClose, initialData, onSave, isEdit }) => {
  const homeBannerDataStructure = {
    image_url: { type: 'image', label: 'Image', required: true },
    link: { type: 'text', label: 'Link', required: false },
    sort_order: { type: 'number', label: 'Sort Order', required: false },
    start_date: { type: 'date', label: 'Effective Start Date', required: true },
    end_date: { type: 'date', label: 'Effective End Date', required: true },
  };

  if (!initialData ||   initialData === ' ') {
    initialData = {
      sort_order: 1,
      translations: [
        {
          "language": "en",
        },
        {
          "language": "zh-Hans",
        },
        {
          "language": "zh-Hant",
        }
      ]
    };
  }

  return (
    <BaseAddEditModal
      isEdit={isEdit}
      isOpen={isOpen}
      onClose={onClose}
      initialData={initialData}
      onSave={onSave}
      dataStructure={homeBannerDataStructure}
      tableName="home_banner"
      isMultiLanguageSupported={true}
    />
  );
};

export default AddEditHomeBannerModal;






